import { FC } from 'react'
import { useLocation } from 'react-router-dom'
import { DisplayTimezoneProvider } from 'src/modules/core/context'
import { shouldShowIntercom } from 'src/modules/core/utils/intercom.utils'
import { IntercomChat } from 'src/modules/intercom'
import classes from './secondary-layout.module.scss'

export const SecondaryLayout: FC = ({ children }) => {
  const location = useLocation()
  const showIntercomChat = shouldShowIntercom(location.pathname)

  return (
    <DisplayTimezoneProvider>
      <IntercomChat show={showIntercomChat} />
      <div className={classes.root}>{children}</div>
    </DisplayTimezoneProvider>
  )
}
